import { useEffect } from 'react';
import { BuyerUserPermissions, DEFAULT_BUYER_USER_PERMISSIONS } from '@dill/dill-shared';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { getBuyerAndMainBuyerDetails } from '../../redux/services/buyersService';
import { updateCurrentUserBuyerPermissions } from '../../redux/globalSlices/buyersSlice';

/**
 * Hook that returns the current user's buyer permissions for the selected main buyer.
 * Fetches buyer details if not already loaded and updates the global Redux state.
 */
export const useBuyerUserPermissions = (): {
  buyerUserPermissions: BuyerUserPermissions;
  buyerUserCanView: boolean;
  buyerUserCanPay: boolean;
} => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { selectedMainBuyer, currentUserBuyerPermissions } = useAppSelector(
    (state) => state.buyers
  );

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!selectedMainBuyer?.id) return;
      const res = await dispatch(
        getBuyerAndMainBuyerDetails({ mainBuyerId: selectedMainBuyer.id })
      );
      if (res.type === 'buyers/getBuyerAndMainBuyerDetails/fulfilled') {
        const payload: any = res.payload;
        const details = payload?.data?.buyerDetails;
        if (details?.usersEmailsDetails) {
          const myPermissions: BuyerUserPermissions =
            details.usersEmailsDetails.find((u: any) => u.userId === user?.id)?.permissions ||
            DEFAULT_BUYER_USER_PERMISSIONS;
          dispatch(updateCurrentUserBuyerPermissions(myPermissions));
        }
      }
    };
    fetchPermissions();
  }, [selectedMainBuyer?.id, user?.id]);

  return {
    buyerUserPermissions: currentUserBuyerPermissions,
    buyerUserCanView: currentUserBuyerPermissions.includes('VIEWER'),
    buyerUserCanPay: currentUserBuyerPermissions.includes('PAYER'),
  };
};
